// components/Employee/UpdateEmployee.js
import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Input } from '../UI/Input.js';
import { Button } from '../UI/Button.js';
import { Dropdown } from '../UI/Dropdown.js';
import DatePicker from '../Common/DatePicker';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';

const UpdateEmployee = () => {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
  const [name, setName] = useState('');
  const [surnames, setSurnames] = useState('');
  const [birthDate, setBirthDate] = useState(null);
  const [pin, setPin] = useState('');
  const [username, setUsername] = useState('');
  const [pwd, setPwd] = useState('');
  const [roles, setRoles] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const fetchEmployees = async () => {
  try {
    const response = await api.get('/userlist');
    setEmployees(response.data);
  } catch (error) {
    console.error('Failed to fetch employees', error);
  }
};

  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      if (!selectedEmployeeId) return;
	  
      const selectedEmployee = employees.find((employee) => employee.user_id === parseInt(selectedEmployeeId));
	  console.log("selectedEmployee:", selectedEmployee);
      if (selectedEmployee) {
        setName(selectedEmployee.name);
        setSurnames(selectedEmployee.surnames);
        setBirthDate(selectedEmployee.birth_date ? new Date(selectedEmployee.birth_date) : null);
		setUsername(selectedEmployee.username)
		
		// Fetch role
      try {
        const roleRes = await api.get(`/userrole/${selectedEmployee.user_id}`);
        const role = roleRes.data;
        console.log("Fetched role:", role);
        if (role?.role_id) {
          setSelectedRoleId(role.role_id.toString()); // Ensure it's a string for dropdown
        }
      } catch (err) {
        console.error("Failed to fetch role", err);
      }
    }
  };

  fetchEmployeeDetails();
}, [selectedEmployeeId, employees]);
  
    useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await api.get('/roles');
        setRoles(response.data);
      } catch (error) {
        console.error('Failed to fetch roles', error);
      }
    };
    fetchRoles();
  }, []);
  
    useEffect(() => {
    if (selectedRoleId) {
      const selectedRole = roles.find((role) => role.role_id === parseInt(selectedRoleId));
	  console.log("selectedRole:", selectedRole);
    }
  }, [selectedRoleId, roles]);

  const handleUpdate = async () => {
    try {
      const payload = {
        name,
        surnames,
        secret_pin: pin || undefined, // Send pin only if it has a value
		username: username || undefined,
	    password: pwd || undefined,
		role_id: selectedRoleId
      };
      if (birthDate) {
        payload.birth_date = birthDate.toLocaleDateString('en-CA');
      }
	  else{
          payload.birth_date = undefined;
      }
      await api.post(`/employees/${selectedEmployeeId}`, payload);
      alert('Employee updated successfully!');
	  // Reset fields after successful update
      setSelectedEmployeeId(''); // Reset dropdown
      setName('');
      setSurnames('');
      setBirthDate(null);
      setPin('');
	  setUsername('');
	  setPwd('');
	  setSelectedRoleId('');
	  fetchEmployees();
    } catch (error) {
      console.error('Employee update failed', error);
      alert('Employee update failed. Please check the input.');
    }
  };

  return (
    <div>
      <h2>Modificar Empleado</h2>
      <FullWidth>
        <Dropdown value={selectedEmployeeId} onChange={(e) => setSelectedEmployeeId(e.target.value)} required >
          <option value="">Selecciona empleado</option>
          {employees.map((employee) => (
            <option key={employee.user_id} value={employee.user_id}>
              {employee.name} {employee.surnames}
            </option>
          ))}
        </Dropdown>
      </FullWidth>
      <FormContainer>
        <Input type="text" placeholder="Nombre" value={name} onChange={(e) => setName(e.target.value)} />
        <Input type="text" placeholder="Apellidos" value={surnames} onChange={(e) => setSurnames(e.target.value)} />
        <FullWidth>
          <DatePicker selected={birthDate} placeholder="Fecha de nacimiento" onChange={(date) => setBirthDate(date)} />
        </FullWidth>
        <FullWidth>
          <Input type="text" placeholder="PIN" value={pin} onChange={(e) => setPin(e.target.value)} />
        </FullWidth>
		<Input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required />
		<div style={{ position: 'relative' }}>
		<Input
           type={showPassword ? 'text' : 'password'}
           placeholder="Password"
           value={pwd}
           onChange={(e) => setPwd(e.target.value)}
           required
         />
		 <span
             onClick={() => setShowPassword(prev => !prev)}
             style={{
               position: 'absolute',
               right: '10px',
               top: '35%',
               transform: 'translateY(-50%)',
               cursor: 'pointer'
             }}
           >
             {showPassword ? '🙈' : '👁️'}
           </span>
         </div>
		<FullWidth>
        <Dropdown value={selectedRoleId} onChange={(e) => setSelectedRoleId(e.target.value)} required>
			<option value="">Selecciona el rol del empleado</option>
			{selectedRoleId && (
				<option value={selectedRoleId}>
				{
					roles.find((role) => role.role_id.toString() === selectedRoleId)?.role_title ||
					'Rol actual'
				}
				</option>
			)}
			{roles
				.filter((role) => role.role_id.toString() !== selectedRoleId)
				.map((role) => (
				<option key={role.role_id} value={role.role_id}>
					{role.role_title}
				</option>
				))}
			</Dropdown>
      </FullWidth>
        <FullWidth>
          <Button onClick={handleUpdate}>Modificar</Button>
        </FullWidth>
      </FormContainer>
    </div>
  );
};

export default UpdateEmployee;